import React from 'react';

import { SsrModule } from 'app/constants/ssrModules';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import Container from '../../components/Container';
import PrematchRootMenu from '../../submodules/PrematchMenu/RootMenu';

const HomepageMenu: React.FC = () => {
  return (
    <Container ssrDataId={SsrModule.LEFT_MENU_HOMEPAGE}
               activeLevel="0">
      <ErrorBoundary>
        <PrematchRootMenu />
      </ErrorBoundary>
    </Container>
  );
};

export default HomepageMenu;
